export default "__VITE_ASSET__DWU3Il58__"